let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("6YPzu")]).then(() => parcelRequire('8mWe6'));